document.addEventListener('DOMContentLoaded', function () {
  let lastSwiperActiveIndex = null;

  const volumeFader = function (video, fadeIn = false, postFade = () => {}) {
    const epsilon = 0.01; // Small threshold to handle floating-point precision issues

    if (fadeIn) {
      clearInterval(video.interval);
      video.interval = setInterval(() => {
        if (video.volume < 1 - epsilon) {
          video.volume = Math.min(Math.round((video.volume + 0.1) * 10) / 10, 1);
          console.log(`Fading in volume: ${video.volume}`);
        } else {
          clearInterval(video.interval);
          console.log('Volume is at maximum.');

          if (postFade && typeof postFade === 'function') {
            postFade();
          }
        }
      }, 100);
    } else {
      clearInterval(video.interval);
      video.interval = setInterval(() => {
        if (video.volume > epsilon) {
          video.volume = Math.max(Math.round((video.volume - 0.1) * 10) / 10, 0);
          console.log(`Fading out volume: ${video.volume}`);
        } else {
          video.volume = 0;
          clearInterval(video.interval);
          console.log('Volume is at zero.');

          if (postFade && typeof postFade === 'function') {
            postFade();
          }
        }
      }, 100);
    }
  };

  const canPlaySound = (el) => {
    return !!!el.hasAttribute('data-component-is-muted');
  };

  const reinitializeSwiper = () => {
    const swiperEl = document.querySelector('swiper-container');

    if (swiperEl && swiperEl.swiper) {
      swiperEl.swiper.off('activeIndexChange');
    }

    const currentSwiperEl = document.querySelector('swiper-container');

    if (currentSwiperEl && currentSwiperEl.swiper) {
      currentSwiperEl.swiper.params.mousewheel = {
        ...currentSwiperEl.swiper.params.mousewheel,
        sensitivity: 0.5,
        thresholdDelta: 10,
      };

      // Set first active index
      lastSwiperActiveIndex = currentSwiperEl.swiper.activeIndex;

      currentSwiperEl.swiper.on('activeIndexChange', () => {
        const currentIndex = currentSwiperEl.swiper.activeIndex;

        // activeIndexChange gets called by swiper on resize too, so we're keeping track of the last active index before resize and comparing
        // If index is not changed, do nothing!
        if (currentIndex === lastSwiperActiveIndex) return;
        lastSwiperActiveIndex = currentIndex;

        if (currentIndex >= 0 && currentIndex < currentSwiperEl.swiper.slides.length) {
          const currentSlide = currentSwiperEl.swiper.slides[currentIndex];

          if (currentSlide) {
            const deferredMedia = currentSlide.querySelector('deferred-media');

            if (deferredMedia !== null) {
              if (window.pauseAllMedia) window.pauseAllMedia();

              if (!deferredMedia.hasAttribute('loaded')) {
                const mediaPoster = deferredMedia.querySelector('.deferred-media__poster');
                if (mediaPoster) mediaPoster.click();

                // Loading is async so we need to wait a bit for javascript to append the video to the DOM after clicking on the poster
                window.setTimeout(() => {
                  const media = deferredMedia.querySelector('video, model-viewer, iframe');
                  if (media && media.volume > 0) media.volume = 0;

                  if (media) {
                    if (canPlaySound(swiperEl)) {
                      volumeFader(media, true);
                    }
                  }
                }, 10);
              } else {
                const media = deferredMedia.querySelector('video, model-viewer, iframe');
                if (media && media.tagName.toLowerCase() === 'video') {
                  if (media.readyState >= 3) {
                    if (media && media.volume > 0) media.volume = 0;
                    media.play();

                    if (media && canPlaySound(swiperEl)) {
                      volumeFader(media, true);
                    }
                  } else {
                    media.oncanplay = function () {
                      if (media && media.volume > 0) media.volume = 0;
                      media.play();
                      if (media && canPlaySound(swiperEl)) {
                        volumeFader(media, true);
                      }
                    };
                  }
                }
              }
            }
          }
        }
      });

      const onUGCSliderInView = (entries, observer) => {
        const currentIndex = currentSwiperEl.swiper.activeIndex;

        if (currentIndex >= 0 && currentIndex < currentSwiperEl.swiper.slides.length) {
          const currentSlide = currentSwiperEl.swiper.slides[currentIndex];

          if (currentSlide) {
            const deferredMedia = currentSlide.querySelector('deferred-media');

            if (deferredMedia !== null) {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  const media = deferredMedia.querySelector('video, model-viewer, iframe');
                  if (!deferredMedia.hasAttribute('loaded')) {
                    const mediaPoster = deferredMedia.querySelector('.deferred-media__poster');
                    if (media && media.volume) media.volume = 0;
                    if (mediaPoster) mediaPoster.click();
                    if (media && canPlaySound(swiperEl)) volumeFader(media, true);
                  } else {
                    if (media && media.tagName.toLowerCase() === 'video') {
                      if (media.readyState >= 3) {
                        if (media && media.volume) media.volume = 0;
                        media.play();
                        if (media && canPlaySound(swiperEl)) volumeFader(media, true);
                      } else {
                        media.oncanplay = function () {
                          if (media && media.volume) media.volume = 0;
                          media.play();
                          if (media && canPlaySound(swiperEl)) volumeFader(media, true);
                        };
                      }
                    }
                  }
                } else {
                  if (window.pauseAllMedia) window.pauseAllMedia();
                }
              });
            }
          }
        }
      };

      const observer = new IntersectionObserver(onUGCSliderInView, {
        root: null,
        threshold: 0.5,
      });

      observer.observe(currentSwiperEl);

      const volumeControls = currentSwiperEl.querySelectorAll('.ugc-slider__volume-control');
      if (volumeControls) {
        volumeControls.forEach((volumeControl) => {
          volumeControl.addEventListener('click', () => {
            const mediaList = currentSwiperEl.querySelectorAll('video, model-viewer, iframe');

            if (!mediaList || !mediaList.length) return;

            if (canPlaySound(swiperEl)) {
              swiperEl.setAttribute('data-component-is-muted', true);
              mediaList.forEach((media) => {
                volumeFader(media, false);
              });
              console.log('Muting...');
            } else {
              swiperEl.removeAttribute('data-component-is-muted');
              mediaList.forEach((media) => {
                volumeFader(media, true);
              });
              console.log('Unmuting...');
            }
          });
        });
      }
    }
  };

  reinitializeSwiper();

  document.addEventListener('shopify:section:load', reinitializeSwiper);
  document.addEventListener('shopify:block:select', reinitializeSwiper);
  document.addEventListener('shopify:block:deselect', reinitializeSwiper);

  const swiperEl = document.querySelector('swiper-container');

  const hasVideo = swiperEl && swiperEl.querySelector('video') !== null;

  if (swiperEl && swiperEl.getAttribute('autoplay') === 'true' && hasVideo) {
    swiperEl.addEventListener('mouseenter', () => {
      swiperEl.swiper.autoplay.stop();
    });

    swiperEl.addEventListener('mouseleave', () => {
      swiperEl.swiper.autoplay.start();
    });
  }
});
